import { ERROR_MESSAGE } from "./constants";

// 영문과 숫자만 허용
export const alphaNumericOnly = value => {
    const regex = /[^a-z0-9]/g;
    return value.replace(regex, '');
};

// 닉네임 유효성 검사
export const validateNickname = (nickname) => {
    if (nickname.length < 2 || nickname.length > 10) {
        return ["nickname", ERROR_MESSAGE.NICKNAME_EDIT];
    }
    // 여기에 추가적인 유효성 검사 로직 (예: 중복 검사)도 추가 가능
    return ["success", ERROR_MESSAGE.NICKNAME_EXISTENCE];
};

// 숫자 한글 체크 , 천단위 콤마
export const formatLocalString = value => {
    // null, undefined 또는 빈 문자열 체크
    if (value === null || value === undefined || value === '') {
        return '0';
    }
    
    // 입력값이 문자열이고, 숫자로만 구성되어 있다면 숫자로 변환
    if (typeof value === 'string' && !isNaN(value)) {
        value = Number(value);
    }

    // 입력값이 숫자인 경우, toLocaleString을 사용하여 현지화된 문자열로 변환
    if (typeof value === 'number' && !isNaN(value)) {
        return value.toLocaleString();
    }

    // 변환할 수 없는 값인 경우 기본값 반환 (에러를 던지지 않음)
    console.warn('Invalid value for formatLocalString:', value);
    return '0';
};

// 숫자만
export const numericRegex = value => {
    const regex = /[^0-9]/g;
    return value.replace(regex, '');
};

export const validateInput = (input, isChar = false) => {
    const regExp = /[{}[\]?.,;:|)*~`!^_+<>@#$%&=('""]/g;

    const hasSpecialCharacter = regExp.test(input);
    const hasNumber = /\d/.test(input);
    const hasLetter = /[A-Za-z]/.test(input);
    if (isChar) {
        // 특수문자, 숫자, 영문자 중 하나라도 없으면 false 반환
        if (!hasSpecialCharacter || !hasNumber || !hasLetter) {
            return false;
        }
    } else {
        if (hasSpecialCharacter || !hasNumber || !hasLetter) {
            return false;
        }
    }
    return true;
};


export const emailRegex = value => {
    // 이메일 주소를 검사하는 정규식
    const pattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    // .test() 메서드를 사용하여 주어진 value가 정규식과 일치하는지 검사
    return pattern.test(value);
};

// 비밀번호 유효성 검사
export const validatePassword = (password) => {
    // 길이 체크 (8~16자)
    if (password.length < 8 || password.length > 16) {
        return false;
    }
    
    // validateInput 함수를 사용하여 특수문자, 숫자, 영문자 포함 여부 체크
    return validateInput(password, true);
};

// 비밀번호 일치 여부 체크
export const validatePasswordMatch = (password, confirmPassword) => {
    return password === confirmPassword;
};

// 전화번호 포맷팅 (하이픈 추가)
export const formatPhoneNumber = (phoneNumber) => {
    // null, undefined, 빈 배열, 빈 문자열 체크
    if (!phoneNumber || (Array.isArray(phoneNumber) && phoneNumber.length === 0) || phoneNumber === '') {
        return ''; // 빈 문자열 반환
    }
    
    // 문자열이 아닌 경우 문자열로 변환
    const phoneStr = String(phoneNumber);
    
    // 숫자만 추출
    const numbers = phoneStr.replace(/[^0-9]/g, '');
    
    // 숫자가 없는 경우 빈 문자열 반환
    if (numbers.length === 0) return '';
    
    // 11자리 번호인 경우 (010-xxxx-xxxx)
    if (numbers.length === 11) {
        return `${numbers.slice(0, 3)}-${numbers.slice(3, 7)}-${numbers.slice(7)}`;
    }
    // 10자리 번호인 경우 (02-xxx-xxxx 등)
    else if (numbers.length === 10) {
        return `${numbers.slice(0, 2)}-${numbers.slice(2, 6)}-${numbers.slice(6)}`;
    }
    
    return numbers;
};

// 아이디 유효성 검사
export const validateUserId = (userid) => {
    // 길이 체크 (8자 이상)
    if (userid.length < 8) {
        return {
            isValid: false,
            message: ERROR_MESSAGE.ID_NOMATCH
        };
    }

    // 영문자와 숫자만 허용하는 정규식
    const idRegex = /^[a-zA-Z0-9]+$/;
    if (!idRegex.test(userid)) {
        return {
            isValid: false,
            message: ERROR_MESSAGE.ID_NOMATCH
        };
    }

    // 영문자와 숫자가 각각 최소 1개 이상 포함되어 있는지 확인
    const hasLetter = /[a-zA-Z]/.test(userid);
    const hasNumber = /[0-9]/.test(userid);
    
    if (!hasLetter || !hasNumber) {
        return {
            isValid: false,
            message: ERROR_MESSAGE.ID_REQUIREMENT
        };
    }

    return {
        isValid: true,
        message: ''
    };
};

// 특수문자 포함 여부 체크
export const hasSpecialChar = (str) => {
    const specialChar = /[!@#$%^&*(),.?":{}|<>]/g;
    return specialChar.test(str);
};

    // 비밀번호 변경 유효성 검사
    export const validateChangePassword = (password) => {
    // 영문, 숫자 조합 6~15자
    const passwordRegex = /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d]{6,15}$/;
    
    if (!passwordRegex.test(password)) {
        return {
        isValid: false,
        message: "비밀번호는 영문, 숫자 조합 6~15자로 입력해주세요."
        };
    }

    return {
        isValid: true,
        message: ""
    };
    };

    // 비밀번호 일치 여부 검사
    export const validatePasswordConfirm = (password, repassword) => {
    if (password !== repassword) {
        return {
        isValid: false,
        message: "비밀번호가 일치하지 않습니다."
        };
    }

    return {
        isValid: true,
        message: ""
    };
};

// 회원가입용 비밀번호 유효성 검사
export const validateRegisterPassword = (password) => {
    // 특수문자 체크
    const hasSpecialChar = /[!@#$%^&*(),.?":{}|<>]/g.test(password);
    if (hasSpecialChar) {
        return {
            isValid: false,
            message: "특수문자 사용이 불가합니다."
        };
    }

    // 길이 체크
    if (password.length < 8) {
        return {
            isValid: false,
            message: "8자 이상 입력해주세요."
        };
    }

    // 영문, 숫자 조합 체크
    const hasLetter = /[A-Za-z]/.test(password);
    const hasNumber = /[0-9]/.test(password);
    if (!hasLetter || !hasNumber) {
        return {
            isValid: false,
            message: "영문, 숫자를 조합하여 입력해주세요."
        };
    }

    return {
        isValid: true,
        message: ""
    };
};

// 회원가입용 아이디 유효성 검사
export const validateRegisterId = (userid) => {
    // 길이 체크 (4~16자)
    if (userid.length < 4 || userid.length > 16) {
        return {
            isValid: false,
            message: "영문소문자/숫자 포함 4~16자로 입력해 주세요."
        };
    }

    // 영문 소문자와 숫자만 허용하는 정규식
    const idRegex = /^[a-z0-9]+$/;
    if (!idRegex.test(userid)) {
        return {
            isValid: false,
            message: "영문소문자/숫자 포함 4~16자로 입력해 주세요."
        };
    }

    // 영문 소문자와 숫자가 각각 최소 1개 이상 포함되어 있는지 확인
    const hasLowerCase = /[a-z]/.test(userid);
    const hasNumber = /[0-9]/.test(userid);
    
    if (!hasLowerCase || !hasNumber) {
        return {
            isValid: false,
            message: "영문소문자/숫자 포함 4~16자로 입력해 주세요."
        };
    }

    return {
        isValid: true,
        message: ''
    };
};

// 회원가입용 비밀번호 유효성 검사 (영문소문자/숫자/특수문자 포함)
export const validateJoinPassword = (password) => {
    // 길이 체크 (8~16자)
    if (password.length < 8 || password.length > 16) {
        return {
            isValid: false,
            message: "영문소문자/숫자/특수문자 포함 8~16자로 입력해 주세요."
        };
    }

    // 영문 소문자, 숫자, 특수문자 포함 여부 체크
    const hasLowerCase = /[a-z]/.test(password);
    const hasNumber = /[0-9]/.test(password);
    const hasSpecialChar = /[!@#$%^&*(),.?":{}|<>]/.test(password);
    
    if (!hasLowerCase || !hasNumber || !hasSpecialChar) {
        return {
            isValid: false,
            message: "영문소문자/숫자/특수문자 포함 8~16자로 입력해 주세요."
        };
    }

    return {
        isValid: true,
        message: ""
    };
};

// URL 포맷팅 (프로토콜 추가)
export const formatUrl = (url) => {
    if (!url) return '#';
    
    // 이미 http:// 또는 https://로 시작하는 경우
    if (url.startsWith('http://') || url.startsWith('https://')) {
        return url;
    }
    
    // 프로토콜이 없는 경우 https:// 추가
    return `https://${url}`;
};

// 사업자 등록 번호 유효성 검증 함수
export const validateBusinessNumber = (businessNum) => {
    // 숫자만 추출
    const cleanNum = businessNum.replace(/[^0-9]/g, '');
    
    // 10자리 숫자가 아닌 경우
    if (cleanNum.length !== 10) {
        return {
            isValid: false,
            message: '사업자 등록 번호는 10자리 숫자입니다.'
        };
    }
    
    // 체크섬 알고리즘 적용 (국세청 표준)
    const checkArray = [1, 3, 7, 1, 3, 7, 1, 3, 5];
    let sum = 0;
    
    // 첫 8자리 계산
    for (let i = 0; i < 8; i++) {
        sum += parseInt(cleanNum[i]) * checkArray[i];
    }
    
    // 9번째 자리 특별 계산
    const ninthDigit = parseInt(cleanNum[8]) * checkArray[8];
    sum += ninthDigit;
    sum += Math.floor(ninthDigit / 10); // 몫을 더함
    
    // 체크 디지트 계산
    const remainder = sum % 10;
    const checkDigit = remainder === 0 ? 0 : 10 - remainder;
    
    if (checkDigit !== parseInt(cleanNum[9])) {
        return {
            isValid: false,
            message: '올바르지 않은 사업자 등록 번호입니다.'
        };
    }
    
    return {
        isValid: true,
        message: ''
    };
};

// 사업자 등록 번호 포맷팅 함수
export const formatBusinessNumber = (value) => {
    const numbers = value.replace(/[^0-9]/g, '');
    if (numbers.length <= 3) return numbers;
    if (numbers.length <= 5) return `${numbers.slice(0, 3)}-${numbers.slice(3)}`;
    return `${numbers.slice(0, 3)}-${numbers.slice(3, 5)}-${numbers.slice(5, 10)}`;
};
